import { createSelector } from 'reselect';
import includes from 'lodash/includes';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
/**
 * Input selectors
 */ // const fetchingSelector = (state) => state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
/**
 * Available data sources list
 */ export const dataSources = ()=>createSelector([
        (state)=>state[constants.MODULE_ID].dataSources
    ], (dataSourcesState)=>dataSourcesState);
/**
 * Data sources connected to account
 */ export const connectedDataSources = createSelector([
    (state)=>state[constants.MODULE_ID].connectedDataSources
], (connectedDataSourcesState)=>connectedDataSourcesState);
//----------------------------------------------------------------------------------------------------------------------
/**
 * Selects if connect process in progress
 */ export const isConnectInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.CONNECT));
export const hasConnectErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.CONNECT));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Selects if disconnect process in progress
 */ // export const isDisconnectInProgress = createSelector(
//   sendingSelector,
//   (state) => includes(state, actionTypes.DISCONNECT)
// );
//
// export const hasDisconnectErrors = createSelector(
//   errorsSelector,
//   (state) => includes(state, actionTypes.DISCONNECT)
// );
//----------------------------------------------------------------------------------------------------------------------
/**
 * Selects if sync process is in progress
 */ export const isSyncInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.SYNC));
export const hasSyncErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.SYNC));
